module.exports = new __parcel__URL__("keyboard-icon.bed17897.svg").toString();